import React, { Fragment } from "react"
import {
  Card,
  Box,
  Typography,
  Divider,
  CardContent,
  useTheme,
} from "@material-ui/core"
import LockRoundedIcon from "@material-ui/icons/LockRounded"
import moment from "moment"
import PropTypes from "prop-types"
import CrewBillingTotal from "./CrewBillingTotal"
import AdditionalItemsTable from "./AdditionalItemsTable"
import OriginalItemsTable from "./OriginalItemsTable"
import RoleIdentityComponent from "../../Common/RoleIdentityComponent/index"

const CrewBillingCard = ({
  crewDealMemo = {},
  setCrewDealMemo = () => {},
  confirmed = false,
}) => {
  const theme = useTheme()

  // create copy of crew member to manipulate locally
  // expense & additional expense updates on child tables

  const crewMember = crewDealMemo && crewDealMemo.user
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const wrapDate = crewDealMemo && crewDealMemo.end_date
  const hasWrapped = moment().isAfter(wrapDate, "day")
  const daysAgo = hasWrapped ? moment().diff(wrapDate, "days") : 0 // days ago if has wrapped is true

  if (crewDealMemo && crewDealMemo.shoot_id && !crewMember) {
    return null
  } else {
    return (
      <Fragment>
        <Card style={{ padding: "20px" }}>
          <CardContent>
            <Box
              display="flex"
              flexDirection={viewportWidth > 600 ? "row" : "column"}
              justifyContent={
                viewportWidth > 600 ? "space-between" : "flex-start"
              }
              alignItems={viewportWidth > 600 ? "center" : "flex-start"}
            >
              <RoleIdentityComponent role={crewMember} showAvatar crewFacing />
              <Box
                display="flex"
                flexDirection="column"
                alignItems={viewportWidth > 600 ? "flex-end" : "flex-start"}
                width={viewportWidth < 600 ? "100%" : "50%"}
                marginTop={viewportWidth > 600 ? "0" : "15px"}
              >
                {/*  when available, will need to factor in crewMember.user_status (string val) */}
                {hasWrapped ? (
                  <Fragment>
                    <Typography
                      variant="subtitle1"
                      style={
                        viewportWidth < 600
                          ? {
                              fontSize: "13px",
                              textAlign: "left",
                            }
                          : null
                      }
                    >
                      Shoot wrapped on{" "}
                      {moment(wrapDate).format("M/D/YY[ @ ]h:mm A")}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={
                        viewportWidth < 600
                          ? {
                              fontWeight: 600,
                              color: "#C9BE3B",
                              fontSize: "13px",
                              textAlign: "left",
                            }
                          : {
                              fontWeight: 600,
                              color: "#C9BE3B",
                            }
                      }
                    >
                      {daysAgo} days ago
                    </Typography>
                  </Fragment>
                ) : (
                  <Typography variant="subtitle1">
                    This shoot has not yet wrapped.
                  </Typography>
                )}
              </Box>
            </Box>
            {/* Original Items Table */}
            <OriginalItemsTable
              crewDealMemo={crewDealMemo}
              setCrewDealMemo={setCrewDealMemo}
              confirmed={confirmed}
            />
            <Divider style={{ marginTop: "20px", marginBottom: "20px" }} />
            {/* Additional Table - inputs to add new expenses */}
            <AdditionalItemsTable
              crewDealMemo={crewDealMemo}
              setCrewDealMemo={setCrewDealMemo}
              confirmed={confirmed}
            />
            {/* Total below */}
            <Box display="flex" mt={3} justifyContent="flex-end">
              {viewportWidth > 600 ? <Box width="50%" /> : null}
              <Box
                width={viewportWidth > 600 ? "50%" : "100%"}
                marginLeft={viewportWidth > 600 ? "20%" : "0px"}
                marginRight={viewportWidth > 600 ? "20px" : "0px"}
                flexShrink={1}
              >
                <CrewBillingTotal data={crewMember} />
              </Box>
            </Box>
          </CardContent>
        </Card>
        {confirmed && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={2}
            color={theme.palette.primary.main}
          >
            <LockRoundedIcon />
            <Typography>
              For viewing only, this bill has been submitted.
            </Typography>
          </Box>
        )}
      </Fragment>
    )
  }
}

CrewBillingCard.propTypes = {
  crewDealMemo: PropTypes.object,
  setCrewDealMemo: PropTypes.func,
  confirmed: PropTypes.bool,
}

export default CrewBillingCard
